(function () {
  function getMcpRoot(button) {
    return button.closest('[data-mcp]');
  }

  function setActiveTab(tabs, activeButton) {
    tabs.forEach(function (tab) {
      var isActive = tab === activeButton;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function hidePanels(panels) {
    panels.forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    });
  }

  function showPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-active');
    panel.removeAttribute('hidden');
  }

  function isHashUrl(url) {
    return !url || url.indexOf('#') !== -1;
  }

  function getCtaUrl(button) {
    var root = getMcpRoot(button);
    var allUrl = (root && root.getAttribute('data-mcp-all-url')) || '/collections/all';
    var ctaUrl = button.getAttribute('data-mcp-cta-url') || '';
    var tabUrl = button.getAttribute('data-mcp-url') || '';

    if (ctaUrl && !isHashUrl(ctaUrl)) return ctaUrl;
    if (isHashUrl(ctaUrl) || isHashUrl(tabUrl)) return allUrl;

    return tabUrl || allUrl;
  }

  function updateCta(root, url) {
    var cta = root.querySelector('[data-mcp-cta]');
    if (!cta) return;
    var allUrl = root.getAttribute('data-mcp-all-url') || '/collections/all';
    cta.setAttribute('href', isHashUrl(url) ? allUrl : url);
  }

  function updateHeading(root, button) {
    var heading = root.querySelector('[data-mcp-heading]');
    if (!heading || !button) return;
    heading.textContent = button.textContent.trim();
  }

  function activateProductsPanel(root, key) {
    var panels = root.querySelectorAll('[data-mcp-products]');
    hidePanels(panels);
    showPanel(root.querySelector('[data-mcp-products="' + key + '"]'));
  }

  function activateSubpanel(root, colKey) {
    var subpanels = root.querySelectorAll('[data-mcp-subpanel]');
    hidePanels(subpanels);
    showPanel(root.querySelector('[data-mcp-subpanel="' + colKey + '"]'));
  }

  function hideAllSubpanels(root) {
    var subpanels = root.querySelectorAll('[data-mcp-subpanel]');
    hidePanels(subpanels);
  }

  function handleColumnOneClick(root, button) {
    var colKey = button.getAttribute('data-mcp-key');
    var hasChildren = button.getAttribute('data-mcp-has-children') === 'true';
    var colTabs = root.querySelectorAll('.mcp__tabs [data-mcp-tab]');

    setActiveTab(colTabs, button);

    if (hasChildren) {
      root.classList.add('mcp--has-subnav');
      activateSubpanel(root, colKey);

      var subpanel = root.querySelector('[data-mcp-subpanel="' + colKey + '"]');
      var firstChild = subpanel ? subpanel.querySelector('[data-mcp-tab]') : null;

      if (firstChild) {
        handleColumnTwoClick(root, firstChild);
      }

      return;
    }

    root.classList.remove('mcp--has-subnav');
    hideAllSubpanels(root);
    activateProductsPanel(root, colKey);
    updateCta(root, getCtaUrl(button));
    updateHeading(root, button);
  }

  function handleColumnTwoClick(root, button) {
    var key = button.getAttribute('data-mcp-key');
    var subpanel = button.closest('[data-mcp-subpanel]');
    var subTabs = subpanel ? subpanel.querySelectorAll('[data-mcp-tab]') : [];

    setActiveTab(subTabs, button);
    activateProductsPanel(root, key);
    updateCta(root, getCtaUrl(button));
    updateHeading(root, button);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mcp-tab]');
    if (!button) return;

    // Allow native navigation for collections/all links
    var url = button.getAttribute('data-mcp-url') || button.getAttribute('href') || '';
    if (url.indexOf('/collections/all') !== -1) {
      return;
    }

    event.preventDefault();

    var root = getMcpRoot(button);
    if (!root) return;

    if (button.closest('.mcp__subpanel')) {
      handleColumnTwoClick(root, button);
      return;
    }

    handleColumnOneClick(root, button);
  });
})();

(function () {
  var TEMPLATE_KEY = 'meganav:localization';
  var MENU_HANDLE = 'localization';

  function getHeader() {
    return document.querySelector('[data-section-type="header"]');
  }

  function getTrigger() {
    return document.querySelector('[data-localization-trigger]');
  }

  function getLocalizationPanel() {
    var header = getHeader();
    if (!header) return null;
    return header.querySelector('.meganav[data-menu-handle="' + MENU_HANDLE + '"]');
  }

  function closeOtherMeganavs() {
    var header = getHeader();
    if (!header) return;

    header.querySelectorAll('.meganav.active').forEach(function (panel) {
      if (panel.getAttribute('data-menu-handle') === MENU_HANDLE) return;
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    });

    header.querySelectorAll('[data-meganav-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeLocalizationPanel() {
    var header = getHeader();
    var trigger = getTrigger();
    var panel = getLocalizationPanel();

    if (panel) {
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    }

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (header && !header.querySelector('.meganav.active')) {
      header.classList.remove('dropdown-active');
    }
  }

  function isLocalizationOpen() {
    var panel = getLocalizationPanel();
    return panel && panel.classList.contains('active');
  }

  function activateTemplate() {
    var template = document.querySelector("template[data-template-key='" + TEMPLATE_KEY + "']");
    if (!template) {
      return Promise.resolve(false);
    }

    if (template.hasAttribute('data-has-been-activated')) {
      return Promise.resolve(true);
    }

    return new Promise(function (resolve) {
      var clone = template.content.cloneNode(true);
      template.after(clone);
      template.setAttribute('data-has-been-activated', 'true');
      resolve(true);
    });
  }

  function openLocalizationPanel(trigger) {
    var header = getHeader();
    if (!header || !trigger) return;

    closeOtherMeganavs();

    activateTemplate().then(function () {
      var panel = getLocalizationPanel();
      if (!panel) return;

      panel.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      header.classList.add('dropdown-active');
      panel.style.setProperty('--mega-nav-top-offset', panel.getBoundingClientRect().top + 'px');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-localization-trigger]');
    if (trigger) {
      event.preventDefault();

      if (isLocalizationOpen()) {
        closeLocalizationPanel();
      } else {
        openLocalizationPanel(trigger);
      }

      return;
    }

    var panel = getLocalizationPanel();
    if (!panel || !isLocalizationOpen()) return;

    if (event.target.closest('.meganav[data-menu-handle="' + MENU_HANDLE + '"] .mloc__group-link')) {
      closeLocalizationPanel();
      return;
    }

    if (!event.target.closest('[data-localization]') && !event.target.closest('.meganav[data-menu-handle="' + MENU_HANDLE + '"]')) {
      closeLocalizationPanel();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isLocalizationOpen()) {
      closeLocalizationPanel();
    }
  });
})();
